module.exports = __webpack_public_path__ + "static/0062-c5994ee56e93429719cf75f14ba81706.png";